import { takeLatest, put, call, all, fork } from "redux-saga/effects"

import { PROFILE_COMPLETION_START } from "./actionTypes"

import { ProfileCompletionSuccess, ProfileCompletionError } from "./action"

import { getProfilePercentage } from "./api"

function* calculateCompletionPercentage() {
  try {
    const Response = yield call(getProfilePercentage)
    if (Response.data.avatar === null) {
      localStorage.setItem("avatar", "")
    } else {
      localStorage.setItem("avatar", Response.data.avatar)
    }

    localStorage.setItem("completionPercentage", Response.data.percentage)
    if (Response.status === 200) {
      yield put(ProfileCompletionSuccess(Response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(ProfileCompletionError(error.response.data))
  }
}

export function* calculateCompletionSaga() {
  yield takeLatest(PROFILE_COMPLETION_START, calculateCompletionPercentage)
}

function* profileCompletionSaga() {
  yield all([fork(calculateCompletionSaga)])
}

export default profileCompletionSaga
